module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-carolin.00971fd2.jpg";